<template>
  <div>
    <div class="d-flex justify-content-center" v-if="carregando">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <b-form ref="frmFaturamento" v-if="!carregando">
      <p class="font-size-h6 mb-2">DADOS DA INTEGRAÇÃO</p>
      <div class="separator separator-solid mb-6"></div>

      <b-form-group>
        <div class="checkbox-inline align-items-center">
          <label class="checkbox font-weight-normal">
            <input
              type="checkbox"
              name="faturar"
              v-model="frmFaturamento.faturar"
            />
            <span></span>
            Habilitar faturamento
          </label>

          <label class="checkbox font-weight-normal" v-if="!subconta">
            <input
              type="checkbox"
              name="agrupar_faturamento"
              v-model="frmFaturamento.agruparFaturamento"
            />
            <span></span>
            Agrupar faturamento
          </label>

          <div class="d-inline-flex align-items-center ml-3">
            <label class="mb-0 mr-2 font-weight-normal">Motivo:</label>
            <b-form-select
              v-model="frmFaturamento.motivoIsencao"
              size="sm"
              style="width: auto"
              :state="estadoMotivoIsencao"
              :options="[
                { value: null, text: 'Selecione' },
                { value: 'I', text: 'Isento / Abonado' },
                { value: 'P', text: 'Parceria' },
                {
                  value: 'R',
                  text: 'Pacote / Recorrência (cobrança automática)'
                }
              ]"
            ></b-form-select>
          </div>
        </div>
      </b-form-group>

      <div class="row">
        <div class="col-md-5">
          <b-form-group>
            <label>ID do cliente:</label>
            <b-form-input
              name="idCliente"
              v-model="frmFaturamento.idCliente"
              data-inputmask="'alias': 'integer'"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-5">
          <b-form-group>
            <label
              >ID do solicitante
              <small class="text-muted">(opcional)</small>:</label
            >
            <b-form-input
              name="idSolicitante"
              v-model="frmFaturamento.idSolicitante"
              placeholder="Pode ficar em branco"
              data-inputmask="'alias': 'integer'"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-2">
          <b-form-group>
            <label>&nbsp;</label>
            <button
              type="button"
              class="btn btn-warning btn-block"
              @click.prevent="limparDadosIntegracao"
            >
              Limpar
            </button>
          </b-form-group>
        </div>
      </div>

      <div class="faturamento-planos-card mb-6">
        <div class="faturamento-planos-header">
          <div>
            <p class="font-size-h6 mb-0">FRANQUIAS MÍNIMAS POR GRUPO</p>
            <small class="text-muted">
              Configure a quantidade mínima faturada para cada grupo de envio.
            </small>
          </div>
          <button
            type="button"
            class="btn btn-light-primary btn-sm font-weight-bold"
            @click="adicionarFranquiaMinimaGrupo"
          >
            Adicionar
          </button>
        </div>

        <div class="faturamento-planos-body">
          <div
            class="alert alert-custom alert-light mb-0"
            v-if="franquiasMinimasGrupo.length === 0"
          >
            <div class="alert-text">
              Nenhuma franquia mínima por grupo adicionada.
            </div>
          </div>

          <div
            class="row faturamento-franquia-linha"
            v-for="(franquia, i) in franquiasMinimasGrupo"
            :key="franquia.conta_envio_minimo_id || i"
          >
            <div class="franquia-grupo-campo">
              <b-form-group class="mb-0">
                <label>Grupo de envio:</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum grupo encontrado"
                  :filter="true"
                  :options="gruposTipoEnvio"
                  v-model="franquiasMinimasGrupo[i].grupo"
                  appendTo="mdlConfiguracaoId"
                ></pv-dropdown>
              </b-form-group>
            </div>

            <div class="franquia-quantidade-campo">
              <b-form-group class="mb-0">
                <label>Quantidade mínima:</label>
                <b-form-input
                  name="cemQuantidadeMinima"
                  v-model="franquiasMinimasGrupo[i].cem_quantidade_minima"
                  data-inputmask="'alias': 'integer'"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="franquia-ativo-campo">
              <label class="checkbox font-weight-normal mb-0">
                <input
                  type="checkbox"
                  v-model="franquiasMinimasGrupo[i].cem_ativo"
                />
                <span></span>
                Ativo
              </label>
            </div>

            <div class="franquia-acao-campo">
              <b-button
                variant="danger"
                size="sm"
                class="btn-icon"
                @click="removerFranquiaMinimaGrupo(i)"
              >
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <b-form-group>
        <label>Plano de faturamento padrão:</label>
        <pv-dropdown
          class="form-control"
          optionLabel="text"
          emptyFilterMessage="Nenhum resultado"
          :filter="true"
          :options="planos"
          v-model="defaultDropdown"
          @input="obterPlano"
          appendTo="mdlConfiguracaoId"
          name="idPlano"
        ></pv-dropdown>
      </b-form-group>

      <div class="faturamento-planos-card">
        <div class="faturamento-planos-header">
          <div>
            <p class="font-size-h6 mb-0">PLANOS POR GRUPO DE ENVIO</p>
            <small class="text-muted">
              Configure a faixa e o plano usados no faturamento de cada grupo.
            </small>
          </div>
          <button
            type="button"
            class="btn btn-light-primary btn-sm font-weight-bold"
            @click="adicionarFaixa"
          >
            Adicionar
          </button>
        </div>

        <div class="faturamento-planos-body">
          <div
            class="alert alert-custom alert-light mb-0"
            v-if="faixaPlano.length === 0"
          >
            <div class="alert-text">
              Nenhuma configuração de plano por grupo adicionada.
            </div>
          </div>

          <div
            class="row faturamento-plano-linha"
            v-for="(faixa, i) in faixaPlano"
            :key="i"
          >
            <div class="col-md-4 faturamento-plano-grupo">
              <b-form-group class="mb-0">
                <label>Grupo de envio:</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum grupo encontrado"
                  :filter="true"
                  :options="gruposTipoEnvio"
                  v-model="faixaPlano[i].grupo"
                  @input="alterarGrupoFaixaPlano(i)"
                  appendTo="mdlConfiguracaoId"
                ></pv-dropdown>
              </b-form-group>
            </div>

            <div class="col-md-2 faturamento-plano-faixa">
              <b-form-group class="mb-0">
                <label>Faixa:</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhuma faixa para o grupo"
                  :filter="true"
                  :options="obterFaixasPorLinha(faixaPlano[i])"
                  v-model="faixaPlano[i].faixa"
                  @input="obterFaixaPlano"
                  appendTo="mdlConfiguracaoId"
                ></pv-dropdown>
              </b-form-group>
            </div>

            <div class="col-md-5 faturamento-plano-plano">
              <b-form-group class="mb-0">
                <label>Plano:</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum resultado"
                  :filter="true"
                  :options="planos"
                  v-model="faixaPlano[i].plano"
                  @input="obterFaixaPlano"
                  appendTo="mdlConfiguracaoId"
                ></pv-dropdown>
              </b-form-group>
            </div>

            <div class="col-md-1 d-flex faturamento-plano-acao">
              <b-button
                variant="danger"
                size="sm"
                class="btn-icon align-self-center mt-md-6"
                @click="removerFaixaPlano(i)"
              >
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </div>
        </div>

        <div class="faturamento-planos-footer">
          <span>
            {{ faixaPlano.length }}
            {{ faixaPlano.length === 1 ? "configuração" : "configurações" }}
          </span>
          <small>Use o botão Salvar para gravar as alterações desta aba.</small>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

import Inputmask from "inputmask";

export default {
  props: {
    conta: Object,
    subconta: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      frmFaturamento: {
        idConta: null,
        idCliente: null,
        idSolicitante: null,
        idPlano: null,
        faturar: false,
        agruparFaturamento: false,
        // WEL-5149: só relevante quando faturar = false — I (isento/abonado)
        // ou P (pacote/cobrança automática, sem cadastro no Conexa).
        motivoIsencao: null
      },
      defaultDropdown: {
        text: "Selecione",
        value: null
      },
      planos: [],
      faixas: [],
      faixasPorGrupo: [],
      gruposTipoEnvio: [],
      faixaPlano: [],
      franquiasMinimasGrupo: [],
      snapshotDadosFaturamento: "",
      carregando: true,
      salvando: false
    };
  },

  mounted() {
    this.abrir();
  },

  computed: {
    ...mapGetters(["validatorErrors"]),

    // Estado visual do select de Motivo (WEL-5157): o select aparece sempre
    // — faturamento habilitado e motivo de enquadramento podem conviver.
    // Verde (true) se motivo preenchido; neutro (null) caso contrário.
    estadoMotivoIsencao() {
      return this.frmFaturamento.motivoIsencao ? true : null;
    }
  },

  methods: {
    abrir() {
      const self = this;

      ApiService.post("conta/obter-dados-faturamento", {
        idConta: this.conta.id
      })
        .then((response) => {
          const dados = response.data.data;
          this.planos = dados.planos || [];
          this.faixas = dados.faixas || [];
          this.faixasPorGrupo = this.normalizarFaixasPorGrupo(
            dados.faixasPorGrupo,
            this.faixas
          );
          if (this.faixas.length === 0) {
            this.faixas = this.faixasPorGrupo.reduce(
              (faixas, grupo) => faixas.concat(grupo.faixas || []),
              []
            );
          }
          this.gruposTipoEnvio = this.montarOpcoesGruposTipoEnvio(
            this.faixasPorGrupo
          );
          this.franquiasMinimasGrupo = this.montarFranquiasMinimasGrupoInicial(
            dados.franquiasMinimasGrupo || []
          );

          this.frmFaturamento.idConta = this.conta.id;

          const faturar = dados.faturar;
          this.frmFaturamento.faturar = faturar == "S";
          this.frmFaturamento.motivoIsencao = dados.motivoIsencao || null;

          const integracao = dados.integracao;
          if (integracao) {
            this.frmFaturamento.idCliente = integracao.id_cliente;
            this.frmFaturamento.idSolicitante = integracao.id_solicitante;
            this.frmFaturamento.idPlano = integracao.id_plano;
            this.frmFaturamento.agruparFaturamento =
              integracao.agrupar_faturamento == "S";
          }

          this.defaultDropdown = dados.planoPadrao || {
            text: "Selecione",
            value: null
          };
          const planosConfigurados = Array.isArray(dados.conta_plano)
            ? dados.conta_plano
            : dados.faixasPlano || [];
          this.faixaPlano = this.montarFaixasPlanoInicial(planosConfigurados);

          this.obterFaixaPlano();
          this.atualizarSnapshotsFaturamento();

          this.carregando = false;
        })
        .then(function () {
          self.validacao();

          self.$watch(
            "frmFaturamento",
            function () {
              self.emitirEstadoAlteracaoFaturamento();
            },
            { deep: true }
          );

          self.$watch(
            "faixaPlano",
            function () {
              self.emitirEstadoAlteracaoFaturamento();
            },
            { deep: true }
          );

          self.$watch(
            "franquiasMinimasGrupo",
            function () {
              self.emitirEstadoAlteracaoFaturamento();
            },
            { deep: true }
          );
        });
    },

    validacao() {
      const frmFaturamento = this.$refs["frmFaturamento"];
      const self = this;
      Inputmask().mask(frmFaturamento.querySelectorAll("input"));
      this.fv = formValidation(frmFaturamento, {
        fields: {
          idCliente: {
            validators: {
              // notEmpty: {
              //   message: "Campo obrigatório."
              // },
              blank: {}
            }
          },
          idSolicitante: {
            validators: {
              // notEmpty: {
              //   message: "Campo obrigatório."
              // },
              blank: {}
            }
          },
          idPlano: {
            validators: {
              // callback: {
              //   callback: function () {
              //     if (self.frmFaturamento.idPlano) {
              //       return true;
              //     }
              //     return false;
              //   },
              //   message: "Campo obrigatório."
              // },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    salvar() {
      if (this.salvando) {
        return;
      }

      if (!this.validarDadosFaturamento()) {
        return;
      }

      return this.fv.validate().then((status) => {
        if (status != "Valid") {
          return;
        }

        const payload = this.montarPayloadDadosFaturamento();

        if (
          this.snapshotDadosFaturamento ===
          this.normalizarObjetoFaturamento(payload)
        ) {
          this.$emit("aba-alterada", false);
          return;
        }

        this.salvando = true;
        this.$emit("salvando", true);

        return ApiService.post("conta/salvar-dados-faturamento", payload)
          .then((response) => {
            this.sincronizarRetornoSalvamento(response.data.data || {});
            this.atualizarSnapshotsFaturamento();
            this.$emit("aba-alterada", false);

            Swal.fire({
              title: "MENSAGEM",
              text: "Salvo com sucesso!",
              icon: "success",
              heightAuto: false
            });
          })
          .catch((error) => {
            this.tratarErroSalvarFaturamento(error);
          })
          .finally(() => {
            this.salvando = false;
            this.$emit("salvando", false);
          });
      });
    },
    obterPlano(obj) {
      this.frmFaturamento.idPlano = obj ? obj.value : null;
    },

    montarPayloadDadosFaturamento() {
      return {
        idConta: this.normalizarInteiroPositivo(
          this.frmFaturamento.idConta || this.conta.id
        ),
        faturar: Boolean(this.frmFaturamento.faturar),
        motivoIsencao: this.normalizarMotivoIsencao(
          this.frmFaturamento.motivoIsencao
        ),
        idCliente: this.normalizarInteiroPositivo(
          this.frmFaturamento.idCliente
        ),
        idSolicitante: this.normalizarInteiroPositivo(
          this.frmFaturamento.idSolicitante
        ),
        idPlano: this.normalizarInteiroPositivo(this.frmFaturamento.idPlano),
        agruparFaturamento: Boolean(this.frmFaturamento.agruparFaturamento),
        planos: this.montarPayloadPlanosFaturamento(),
        franquiasMinimasGrupo: this.montarPayloadFranquiasMinimasGrupo()
      };
    },

    normalizarObjetoFaturamento(objeto) {
      return JSON.stringify(objeto || {});
    },

    atualizarSnapshotsFaturamento() {
      this.snapshotDadosFaturamento = this.normalizarObjetoFaturamento(
        this.montarPayloadDadosFaturamento()
      );
    },

    dadosFaturamentoAlterados() {
      return (
        this.snapshotDadosFaturamento !==
        this.normalizarObjetoFaturamento(this.montarPayloadDadosFaturamento())
      );
    },

    emitirEstadoAlteracaoFaturamento() {
      this.$emit("aba-alterada", this.dadosFaturamentoAlterados());
    },

    normalizarInteiroPositivo(valor) {
      const numero = Number(valor);

      return Number.isInteger(numero) && numero > 0 ? numero : null;
    },

    normalizarMotivoIsencao(motivo) {
      return ["I", "P", "R"].includes(motivo) ? motivo : null;
    },

    validarDadosFaturamento() {
      const payload = this.montarPayloadDadosFaturamento();

      if (!payload.idConta) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Conta inválida para salvar a configuração de faturamento.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      if (!payload.faturar && !payload.motivoIsencao) {
        Swal.fire({
          title: "Motivo obrigatório",
          text: 'Selecione o motivo quando "Habilitar faturamento" estiver desmarcado.',
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      if (payload.idCliente && !payload.idPlano) {
        Swal.fire({
          title: "Plano obrigatório",
          text: "Informe o plano de faturamento padrão quando houver ID do cliente.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      return this.validarPlanosFaturamento();
    },

    tratarErroSalvarFaturamento(error) {
      const status = error && error.response && error.response.status;
      const data = error && error.response && error.response.data;
      const mensagem =
        (data && (data.message || data.mensagem)) ||
        "Não foi possível salvar a configuração de faturamento.";
      const errosStore =
        this.validatorErrors && typeof this.validatorErrors === "object"
          ? this.validatorErrors
          : {};
      const errosResposta =
        data && typeof (data.errors || data.erros || data.data) === "object"
          ? data.errors || data.erros || data.data
          : {};
      const errosValidacao = { ...errosStore, ...errosResposta };
      const camposFormulario =
        this.fv && this.fv.getFields ? this.fv.getFields() : {};
      const mensagensValidacao = [];

      Object.keys(errosValidacao).forEach((campo) => {
        const mensagemCampo = this.normalizarMensagemErro(
          errosValidacao[campo]
        );

        if (mensagemCampo) {
          mensagensValidacao.push(mensagemCampo);
        }

        if (
          camposFormulario[campo] &&
          this.fv &&
          this.fv.updateValidatorOption
        ) {
          this.fv
            .updateValidatorOption(
              campo,
              "blank",
              "message",
              mensagemCampo || mensagem
            )
            .updateFieldStatus(campo, "Invalid", "blank");
        }
      });

      if (status === 422) {
        Swal.fire({
          title: "Validação",
          text: mensagensValidacao.length
            ? mensagensValidacao.join("\n")
            : mensagem,
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      if (status === 403) {
        Swal.fire({
          title: "Permissão",
          text: "Você não tem permissão para salvar a configuração de faturamento.",
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      Swal.fire({
        title: "Erro",
        text: mensagem,
        icon: "error",
        heightAuto: false
      });
    },

    normalizarMensagemErro(erro) {
      if (Array.isArray(erro)) {
        return erro
          .map((item) => this.normalizarMensagemErro(item))
          .filter(Boolean)
          .join(" ");
      }

      if (erro && typeof erro === "object") {
        return Object.values(erro)
          .map((item) => this.normalizarMensagemErro(item))
          .filter(Boolean)
          .join(" ");
      }

      return erro === undefined || erro === null ? "" : String(erro);
    },

    sincronizarRetornoSalvamento(dados) {
      const planosRetorno = dados.conta_plano || dados.planos;

      if (Array.isArray(planosRetorno)) {
        this.faixaPlano = this.montarFaixasPlanoInicial(planosRetorno);
      }

      if (Array.isArray(dados.franquiasMinimasGrupo)) {
        this.franquiasMinimasGrupo = this.montarFranquiasMinimasGrupoInicial(
          dados.franquiasMinimasGrupo
        );
      }
    },
    adicionarFaixa() {
      this.faixaPlano.push({
        grupo: {
          text: "Selecione",
          value: null
        },
        faixa: {
          text: "Selecione",
          value: null
        },
        plano: {
          text: "Selecione",
          value: null
        }
      });
      this.obterFaixaPlano();
    },

    normalizarFaixasPorGrupo(faixasPorGrupo, faixas) {
      if (Array.isArray(faixasPorGrupo) && faixasPorGrupo.length > 0) {
        return faixasPorGrupo.map((grupo) => {
          const primeiraFaixa = (grupo.faixas || [])[0] || {};

          return {
            grupo_tipo_envio: grupo.grupo_tipo_envio || {
              grupo_tipo_envio_id: primeiraFaixa.grupo_tipo_envio_id,
              gte_codigo: primeiraFaixa.gte_codigo,
              gte_descricao:
                primeiraFaixa.gte_descricao || "Grupo não informado"
            },
            faixas: grupo.faixas || []
          };
        });
      }

      const grupos = (faixas || []).reduce((grupos, faixa) => {
        const grupo = faixa.grupo_tipo_envio || {
          grupo_tipo_envio_id: faixa.grupo_tipo_envio_id,
          gte_codigo: faixa.gte_codigo,
          gte_descricao: faixa.gte_descricao || "Grupo não informado"
        };
        const idGrupo = grupo.grupo_tipo_envio_id || "sem-grupo";

        if (!grupos[idGrupo]) {
          grupos[idGrupo] = {
            grupo_tipo_envio: grupo,
            faixas: []
          };
        }

        grupos[idGrupo].faixas.push(faixa);
        return grupos;
      }, {});

      return Object.values(grupos);
    },

    montarOpcoesGruposTipoEnvio(faixasPorGrupo) {
      return (faixasPorGrupo || []).map((grupo) => {
        const grupoTipoEnvio = grupo.grupo_tipo_envio || {};
        const idGrupo = grupoTipoEnvio.grupo_tipo_envio_id;
        const codigo = grupoTipoEnvio.gte_codigo;
        const descricao =
          grupoTipoEnvio.gte_descricao || codigo || "Grupo não informado";

        return {
          text: codigo ? `${descricao} (${codigo})` : descricao,
          value: idGrupo,
          grupo_tipo_envio_id: idGrupo,
          grupo_tipo_envio: grupoTipoEnvio
        };
      });
    },

    montarFaixasPlanoInicial(faixasPlano) {
      return (faixasPlano || []).map((item) => {
        const faixa = item.faixa || {};
        const idFaixa =
          faixa.value || faixa.plano_faixa_id || item.plano_faixa_id;
        const grupoTipoEnvio = faixa.grupo_tipo_envio ||
          this.obterGrupoPorFaixa(faixa) ||
          this.obterGrupoPorFaixa({ value: idFaixa }) || {
            grupo_tipo_envio_id: item.grupo_tipo_envio_id
          };
        const grupo = this.obterOpcaoGrupo(grupoTipoEnvio.grupo_tipo_envio_id);
        const idPlano =
          (item.plano && item.plano.value) || item.plano_id || item.idPlano;

        return {
          grupo,
          faixa: this.obterOpcaoFaixa(idFaixa),
          plano: this.obterOpcaoPlano(idPlano)
        };
      });
    },

    valoresIguais(valorA, valorB) {
      return String(valorA || "") === String(valorB || "");
    },

    obterOpcaoGrupo(idGrupo) {
      return (
        this.gruposTipoEnvio.find((grupo) =>
          this.valoresIguais(grupo.value, idGrupo)
        ) || {
          text: "Selecione",
          value: null
        }
      );
    },

    montarFranquiasMinimasGrupoInicial(franquias) {
      return (franquias || []).map((franquia) => ({
        conta_envio_minimo_id: franquia.conta_envio_minimo_id || null,
        conta_id: franquia.conta_id || this.conta.id,
        tipo_envio_id: franquia.tipo_envio_id || null,
        grupo_tipo_envio_id: franquia.grupo_tipo_envio_id || null,
        grupo: this.obterOpcaoGrupo(franquia.grupo_tipo_envio_id),
        cem_quantidade_minima: franquia.cem_quantidade_minima || 0,
        cem_ativo:
          franquia.cem_ativo === undefined || franquia.cem_ativo === null
            ? true
            : Boolean(franquia.cem_ativo)
      }));
    },

    adicionarFranquiaMinimaGrupo() {
      this.franquiasMinimasGrupo.push({
        conta_envio_minimo_id: null,
        conta_id: this.conta.id,
        tipo_envio_id: null,
        grupo_tipo_envio_id: null,
        grupo: {
          text: "Selecione",
          value: null
        },
        cem_quantidade_minima: 0,
        cem_ativo: true
      });
    },

    removerFranquiaMinimaGrupo(index) {
      this.franquiasMinimasGrupo.splice(index, 1);
    },

    montarPayloadFranquiasMinimasGrupo() {
      return this.franquiasMinimasGrupo
        .map((franquia) => ({
          grupo_tipo_envio_id: this.normalizarInteiroPositivo(
            franquia && franquia.grupo ? franquia.grupo.value : null
          ),
          cem_quantidade_minima: Number(
            franquia && franquia.cem_quantidade_minima
              ? franquia.cem_quantidade_minima
              : 0
          ),
          cem_ativo: Boolean(franquia && franquia.cem_ativo)
        }))
        .filter((franquia) => franquia.grupo_tipo_envio_id);
    },

    obterOpcaoFaixa(idFaixa) {
      return (
        this.faixas.find((faixa) =>
          this.valoresIguais(faixa.value, idFaixa)
        ) || {
          text: "Selecione",
          value: null
        }
      );
    },

    obterOpcaoPlano(idPlano) {
      return (
        this.planos.find((plano) =>
          this.valoresIguais(plano.value, idPlano)
        ) || {
          text: "Selecione",
          value: null
        }
      );
    },

    obterGrupoPorFaixa(faixa) {
      const idFaixa = faixa && (faixa.value || faixa.plano_faixa_id);
      const grupo = this.faixasPorGrupo.find((grupo) =>
        (grupo.faixas || []).some((item) =>
          this.valoresIguais(item.value, idFaixa)
        )
      );

      return grupo ? grupo.grupo_tipo_envio : null;
    },

    obterFaixasPorLinha(linha) {
      const idGrupo = linha && linha.grupo ? linha.grupo.value : null;
      const grupo = this.faixasPorGrupo.find((grupo) =>
        this.valoresIguais(grupo.grupo_tipo_envio.grupo_tipo_envio_id, idGrupo)
      );

      return grupo ? grupo.faixas || [] : [];
    },

    alterarGrupoFaixaPlano(index) {
      const linha = this.faixaPlano[index];
      const faixasGrupo = this.obterFaixasPorLinha(linha);
      const faixaSelecionada = linha && linha.faixa ? linha.faixa.value : null;
      const faixaPertenceAoGrupo = faixasGrupo.some((faixa) =>
        this.valoresIguais(faixa.value, faixaSelecionada)
      );

      if (!faixaPertenceAoGrupo) {
        this.$set(this.faixaPlano[index], "faixa", {
          text: "Selecione",
          value: null
        });
      }

      this.obterFaixaPlano();
    },

    obterFaixaPlano() {
      return this.faixaPlano.map((obj) => ({
        grupo_tipo_envio_id: obj && obj.grupo ? obj.grupo.value : null,
        faixa: obj && obj.faixa ? obj.faixa.value : null,
        plano: obj && obj.plano ? obj.plano.value : null
      }));
    },

    removerFaixaPlano(index) {
      this.faixaPlano.splice(index, 1);
      this.obterFaixaPlano();
    },

    montarPayloadPlanosFaturamento() {
      return this.faixaPlano
        .map((item) => ({
          grupo_tipo_envio_id: this.normalizarInteiroPositivo(
            item && item.grupo ? item.grupo.value : null
          ),
          plano_id: this.normalizarInteiroPositivo(
            item && item.plano ? item.plano.value : null
          ),
          plano_faixa_id: this.normalizarInteiroPositivo(
            item && item.faixa ? item.faixa.value : null
          )
        }))
        .filter(
          (item) =>
            item.grupo_tipo_envio_id && item.plano_id && item.plano_faixa_id
        );
    },

    validarPlanosFaturamento() {
      const planos = this.montarPayloadPlanosFaturamento();

      if (planos.length !== this.faixaPlano.length) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Informe grupo, faixa e plano em todas as linhas antes de salvar.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      const franquias = this.montarPayloadFranquiasMinimasGrupo();

      if (franquias.length !== this.franquiasMinimasGrupo.length) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Informe o grupo em todas as franquias mínimas antes de salvar.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      const chavesPlanos = planos.map(
        (item) => `${item.grupo_tipo_envio_id}-${item.plano_faixa_id}`
      );
      const possuiDuplicidadePlanos = chavesPlanos.some(
        (chave, index) => chavesPlanos.indexOf(chave) !== index
      );

      if (possuiDuplicidadePlanos) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Remova configurações duplicadas para o mesmo grupo e faixa.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      const chavesFranquias = franquias.map((item) => item.grupo_tipo_envio_id);
      const possuiDuplicidadeFranquias = chavesFranquias.some(
        (chave, index) => chavesFranquias.indexOf(chave) !== index
      );

      if (possuiDuplicidadeFranquias) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Remova franquias mínimas duplicadas para o mesmo grupo.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      return true;
    },

    limparDadosIntegracao() {
      this.frmFaturamento.idCliente = null;
      this.frmFaturamento.idSolicitante = null;
      this.frmFaturamento.idPlano = null;
      this.defaultDropdown = {
        text: "Selecione",
        value: null
      };
    }
  }
};
</script>

<style scoped>
.faturamento-planos-card {
  border: 1px solid #e8dff2;
  border-radius: 4px;
  overflow: hidden;
}

.faturamento-planos-header,
.faturamento-planos-footer {
  align-items: center;
  background: #f4eefb;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.faturamento-planos-header {
  border-bottom: 1px solid #e8dff2;
}

.faturamento-planos-footer {
  border-top: 1px solid #e8dff2;
}

.faturamento-planos-footer span,
.faturamento-planos-footer small {
  color: #6b6178;
  font-size: 0.86rem;
  font-weight: 700;
}

.faturamento-planos-body {
  background: #ffffff;
  display: grid;
  gap: 0.75rem;
  padding: 0.85rem;
}

.faturamento-plano-linha,
.faturamento-franquia-linha {
  align-items: end;
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  display: grid;
  gap: 0.75rem;
  margin-left: 0;
  margin-right: 0;
  padding: 0.85rem 0.25rem;
}

.faturamento-plano-linha {
  grid-template-columns:
    minmax(220px, 1fr) minmax(150px, 0.65fr) minmax(360px, 1.55fr)
    42px;
}

.faturamento-franquia-linha {
  grid-template-columns: minmax(260px, 1fr) minmax(180px, 0.6fr) 92px 42px;
}

.faturamento-plano-linha > [class*="col-"] {
  max-width: none;
  padding-left: 0;
  padding-right: 0;
  width: auto;
}

.faturamento-plano-acao,
.franquia-acao-campo {
  align-items: center;
  align-self: end;
  justify-content: center;
  justify-self: center;
  width: 42px;
}

.franquia-ativo-campo,
.franquia-acao-campo {
  align-items: center;
  display: flex;
  min-height: 38px;
}

.faturamento-plano-acao .btn-icon,
.franquia-acao-campo .btn-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0 !important;
}

@media (max-width: 767.98px) {
  .faturamento-planos-header,
  .faturamento-planos-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .faturamento-plano-linha,
  .faturamento-franquia-linha {
    grid-template-columns: 1fr;
  }

  .faturamento-plano-acao,
  .franquia-acao-campo {
    justify-content: flex-end;
  }
}
</style>
